import { SVGProps } from 'react';

const GrabModalLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='164'
    height='18'
    viewBox='0 0 164 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.305 13.1893C20.305 14.7795 19.4308 16.0599 17.5279 16.0599C15.625 16.0599 14.7898 14.8573 14.7898 13.1893V8.146H13.9536V13.2276C13.9536 15.3226 15.1329 16.874 17.5284 16.874C19.962 16.874 21.1798 15.206 21.1798 13.2665V8.18486H20.3436L20.305 13.1893Z'
      fill='white'
    />
    <path
      d='M25.7043 8.10706H24.8301L24.792 16.7189L30.8379 16.7578V15.9806L25.6678 15.9433L25.7043 8.10706Z'
      fill='white'
    />
    <path
      d='M36.6941 7.91382C36.1069 7.90168 35.5233 8.01019 34.9791 8.23274C34.4348 8.45529 33.9413 8.78722 33.5285 9.20827C33.1158 9.62932 32.7925 10.1307 32.5783 10.6818C32.3642 11.2328 32.2638 11.8221 32.2831 12.4136C32.2902 13.2956 32.5566 14.1557 33.0485 14.8853C33.5404 15.615 34.2359 16.1814 35.0471 16.5131C35.8583 16.8448 36.7488 16.9269 37.6063 16.749C38.4638 16.5712 39.2497 16.1413 39.8649 15.5138C40.4801 14.8862 40.8969 14.0891 41.0628 13.223C41.2287 12.3569 41.1362 11.4607 40.7969 10.6476C40.4577 9.83447 39.8869 9.14084 39.1567 8.65428C38.4265 8.16772 37.5696 7.91006 36.6941 7.91382ZM36.6561 16.1008C36.1789 16.1094 35.7052 16.019 35.2642 15.8353C34.8232 15.6515 34.4245 15.3783 34.0928 15.0327C33.761 14.6871 33.5034 14.2764 33.336 13.8261C33.1685 13.3759 33.0948 12.8958 33.1193 12.4156C33.1079 11.9354 33.1919 11.4578 33.3664 11.0108C33.5409 10.5638 33.8023 10.1565 34.1354 9.81277C34.4684 9.46907 34.8663 9.19596 35.3056 9.00949C35.745 8.82301 36.2169 8.72695 36.6936 8.72695C37.1704 8.72695 37.6423 8.82301 38.0816 9.00949C38.521 9.19596 38.9189 9.46907 39.2519 9.81277C39.5849 10.1565 39.8464 10.5638 40.0208 11.0108C40.1953 11.4578 40.2793 11.9354 40.2679 12.4156C40.2897 12.9013 40.2115 13.3862 40.0382 13.8399C39.8649 14.2936 39.6004 14.7063 39.2611 15.052C38.9219 15.3977 38.5153 15.6689 38.067 15.8486C37.6187 16.0283 37.1383 16.1126 36.6561 16.0962V16.1008Z'
      fill='white'
    />
    <path d='M0.266403 0H0V0.271518H0.266403V0Z' fill='white' />
    <path
      d='M1.29316 0.349243H1.02881V0.620761H1.29521L1.29316 0.349243Z'
      fill='white'
    />
    <path d='M2.3577 0.775696H2.09131V1.04721H2.3577V0.775696Z' fill='white' />
    <path d='M3.42265 1.16376H3.15625V1.43528H3.42265V1.16376Z' fill='white' />
    <path
      d='M4.48699 1.59021H4.22266V1.86173H4.48854L4.48699 1.59021Z'
      fill='white'
    />
    <path d='M5.51396 1.93945H5.24756V2.21097H5.51396V1.93945Z' fill='white' />
    <path d='M6.50221 2.32758H6.23633V2.59909H6.50221V2.32758Z' fill='white' />
    <path d='M7.45293 2.63794H7.18652V2.90946H7.45293V2.63794Z' fill='white' />
    <path d='M8.32792 2.94781H8.06152V3.21933H8.32792V2.94781Z' fill='white' />
    <path d='M1.36942 1.00836H1.10303V1.27988H1.36942V1.00836Z' fill='white' />
    <path d='M2.28151 1.31873H2.01562V1.59024H2.28151V1.31873Z' fill='white' />
    <path d='M3.23415 1.62909H2.96826V1.90061H3.23415V1.62909Z' fill='white' />
    <path d='M4.18339 1.97833H3.91699V2.24985H4.18339V1.97833Z' fill='white' />
    <path d='M5.13307 2.32758H4.86719V2.59909H5.13307V2.32758Z' fill='white' />
    <path d='M6.08476 2.63794H5.81836V2.90946H6.08476V2.63794Z' fill='white' />
    <path d='M6.99635 2.94781H6.73047V3.21933H6.99635V2.94781Z' fill='white' />
    <path d='M7.83327 3.25818H7.56738V3.53073H7.83327V3.25818Z' fill='white' />
    <path d='M8.67021 3.49084H8.40381V3.76236H8.67021V3.49084Z' fill='white' />
    <path d='M2.39577 1.93945H2.12988V2.21097H2.39577V1.93945Z' fill='white' />
    <path d='M3.19413 2.211H2.92773V2.48252H3.19413V2.211Z' fill='white' />
    <path d='M4.03105 2.48303H3.76465V2.75455H4.03105V2.48303Z' fill='white' />
    <path d='M4.90556 2.75452H4.63916V3.02604H4.90556V2.75452Z' fill='white' />
    <path d='M5.74147 3.02557H5.47559V3.29709H5.74147V3.02557Z' fill='white' />
    <path d='M6.6165 3.33594H6.3501V3.60745H6.6165V3.33594Z' fill='white' />
    <path d='M7.41533 3.56854H7.14893V3.84006H7.41533V3.56854Z' fill='white' />
    <path d='M8.21513 3.84058H7.94873V4.11209H8.21513V3.84058Z' fill='white' />
    <path d='M8.97295 4.07324H8.70654V4.34476H8.97295V4.07324Z' fill='white' />
    <path d='M3.27031 2.83173H3.00391V3.10324H3.27031V2.83173Z' fill='white' />
    <path d='M3.99196 3.02557H3.72607V3.29709H3.99196V3.02557Z' fill='white' />
    <path d='M4.75322 3.25818H4.48682V3.53073H4.75322V3.25818Z' fill='white' />
    <path d='M5.55205 3.49084H5.28564V3.76236H5.55205V3.49084Z' fill='white' />
    <path d='M6.3123 3.72351H6.0459V3.99503H6.3123V3.72351Z' fill='white' />
    <path d='M7.07304 3.95673H6.80664V4.22824H7.07304V3.95673Z' fill='white' />
    <path d='M7.83327 4.18939H7.56738V4.46091H7.83327V4.18939Z' fill='white' />
    <path d='M8.59401 4.38361H8.32812V4.65513H8.59401V4.38361Z' fill='white' />
    <path d='M9.2786 4.57739H9.01221V4.84891H9.2786V4.57739Z' fill='white' />
    <path d='M4.06914 3.64636H3.80273V3.91788H4.06914V3.64636Z' fill='white' />
    <path d='M4.71561 3.80176H4.44922V4.07328H4.71561V3.80176Z' fill='white' />
    <path d='M5.3997 3.99548H5.1333V4.267H5.3997V3.99548Z' fill='white' />
    <path d='M6.12236 4.18939H5.85596V4.46091H6.12236V4.18939Z' fill='white' />
    <path d='M6.80742 4.38361H6.54102V4.65513H6.80742V4.38361Z' fill='white' />
    <path d='M7.52959 4.57739H7.26318V4.84891H7.52959V4.57739Z' fill='white' />
    <path d='M8.21513 4.77124H7.94873V5.04276H8.21513V4.77124Z' fill='white' />
    <path d='M8.89821 4.92615H8.63232V5.19766H8.89821V4.92615Z' fill='white' />
    <path d='M9.5442 5.12048H9.27832V5.392H9.5442V5.12048Z' fill='white' />
    <path d='M4.75322 4.42249H4.48682V4.694H4.75322V4.42249Z' fill='white' />
    <path d='M5.36161 4.53857H5.09521V4.81009H5.36161V4.53857Z' fill='white' />
    <path d='M5.9705 4.69397H5.7041V4.96549H5.9705V4.69397Z' fill='white' />
    <path d='M6.6165 4.84894H6.3501V5.12046H6.6165V4.84894Z' fill='white' />
    <path d='M7.26298 5.00391H6.99658V5.27646H7.26298V5.00391Z' fill='white' />
    <path d='M7.90947 5.1593H7.64307V5.43082H7.90947V5.1593Z' fill='white' />
    <path d='M8.55595 5.31476H8.28955V5.58628H8.55595V5.31476Z' fill='white' />
    <path d='M9.16434 5.46973H8.89795V5.74124H9.16434V5.46973Z' fill='white' />
    <path d='M9.77275 5.62463H9.50635V5.89615H9.77275V5.62463Z' fill='white' />
    <path d='M5.32402 5.12048H5.05762V5.392H5.32402V5.12048Z' fill='white' />
    <path
      d='M5.89371 5.23602H5.62988V5.50754H5.89578L5.89371 5.23602Z'
      fill='white'
    />
    <path d='M6.46464 5.35364H6.19824V5.62516H6.46464V5.35364Z' fill='white' />
    <path d='M7.07304 5.46973H6.80664V5.74124H7.07304V5.46973Z' fill='white' />
    <path
      d='M7.68085 5.62463H7.4165V5.89615H7.68239L7.68085 5.62463Z'
      fill='white'
    />
    <path d='M8.25127 5.74121H7.98486V6.01273H8.25127V5.74121Z' fill='white' />
    <path d='M8.85966 5.8573H8.59326V6.12882H8.85966V5.8573Z' fill='white' />
    <path d='M9.43047 5.97388H9.16406V6.2454H9.43047V5.97388Z' fill='white' />
    <path d='M10.0008 6.09045H9.73438V6.36197H10.0008V6.09045Z' fill='white' />
    <path d='M5.81815 5.78168H5.55176V6.0532H5.81815V5.78168Z' fill='white' />
    <path d='M6.35085 5.8573H6.08496V6.12882H6.35085V5.8573Z' fill='white' />
    <path d='M6.92069 5.97388H6.6543V6.2454H6.92069V5.97388Z' fill='white' />
    <path d='M7.45293 6.05164H7.18652V6.32315H7.45293V6.05164Z' fill='white' />
    <path d='M8.02373 6.16766H7.75732V6.43918H8.02373V6.16766Z' fill='white' />
    <path d='M8.55595 6.28424H8.28955V6.55576H8.55595V6.28424Z' fill='white' />
    <path d='M9.12627 6.362H8.85986V6.63352H9.12627V6.362Z' fill='white' />
    <path d='M9.65849 6.47809H9.39209V6.74909H9.65849V6.47809Z' fill='white' />
    <path d='M10.1907 6.55579H9.9248V6.8273H10.1907V6.55579Z' fill='white' />
    <path
      d='M6.27416 6.40088H6.00879V6.6724H6.27518L6.27416 6.40088Z'
      fill='white'
    />
    <path d='M6.76884 6.43921H6.50244V6.71073H6.76884V6.43921Z' fill='white' />
    <path d='M7.26298 6.55579H6.99658V6.8273H7.26298V6.55579Z' fill='white' />
    <path d='M7.79521 6.63348H7.52881V6.905H7.79521V6.63348Z' fill='white' />
    <path d='M8.28932 6.70917H8.02344V6.98069H8.28932V6.70917Z' fill='white' />
    <path
      d='M8.82217 6.78845H8.55371V7.05997H8.82011L8.82217 6.78845Z'
      fill='white'
    />
    <path d='M9.35136 6.86615H9.08496V7.13767H9.35136V6.86615Z' fill='white' />
    <path
      d='M9.84892 6.94336H9.58252V7.21488H9.8484L9.84892 6.94336Z'
      fill='white'
    />
    <path d='M10.343 7.02161H10.0771V7.29468H10.343V7.02161Z' fill='white' />
    <path d='M6.6165 6.94336H6.3501V7.21488H6.6165V6.94336Z' fill='white' />
    <path d='M7.11063 7.02161H6.84424V7.29468H7.11063V7.02161Z' fill='white' />
    <path d='M7.56523 7.06H7.29883V7.33151H7.56523V7.06Z' fill='white' />
    <path
      d='M8.0613 7.1377H7.79541V7.40921H8.06181L8.0613 7.1377Z'
      fill='white'
    />
    <path d='M8.55595 7.21484H8.28955V7.48636H8.55595V7.21484Z' fill='white' />
    <path d='M9.05006 7.2926H8.78418V7.56412H9.05006V7.2926Z' fill='white' />
    <path d='M9.5442 7.33148H9.27832V7.603H9.5442V7.33148Z' fill='white' />
    <path d='M10.0008 7.40924H9.73438V7.68076H10.0008V7.40924Z' fill='white' />
    <path d='M10.4573 7.44806H10.1909V7.71958H10.4573V7.44806Z' fill='white' />
    <path d='M6.92069 7.48645H6.6543V7.75797H6.92069V7.48645Z' fill='white' />
    <path d='M7.37675 7.52686H7.11035V7.79837H7.37675V7.52686Z' fill='white' />
    <path d='M7.83327 7.60303H7.56738V7.87455H7.83327V7.60303Z' fill='white' />
    <path d='M8.28932 7.64185H8.02344V7.91336H8.28932V7.64185Z' fill='white' />
    <path d='M8.74538 7.68073H8.47949V7.95224H8.74538V7.68073Z' fill='white' />
    <path d='M9.23952 7.75848H8.97363V8.03H9.23952V7.75848Z' fill='white' />
    <path d='M9.69655 7.79938H9.43066V8.0709H9.69655V7.79938Z' fill='white' />
    <path d='M10.1526 7.83569H9.88623V8.10721H10.1526V7.83569Z' fill='white' />
    <path d='M10.5711 7.87451H10.3047V8.14603H10.5711V7.87451Z' fill='white' />
    <path d='M7.18629 7.99109H6.92041V8.26261H7.18629V7.99109Z' fill='white' />
    <path d='M7.60478 8.02997H7.33838V8.30149H7.60478V8.02997Z' fill='white' />
    <path d='M8.02373 8.06885H7.75732V8.34037H8.02373V8.06885Z' fill='white' />
    <path d='M8.48027 8.10712H8.21387V8.37864H8.48027V8.10712Z' fill='white' />
    <path d='M8.93632 8.14606H8.66992V8.41757H8.93632V8.14606Z' fill='white' />
    <path d='M9.35136 8.18494H9.08496V8.45645H9.35136V8.18494Z' fill='white' />
    <path d='M9.81034 8.22375H9.54395V8.49475H9.81034V8.22375Z' fill='white' />
    <path
      d='M10.2294 8.26263H9.96143V8.53415H10.2278L10.2294 8.26263Z'
      fill='white'
    />
    <path d='M10.6853 8.30151H10.4189V8.57303H10.6853V8.30151Z' fill='white' />
    <path d='M7.37675 8.4953H7.11035V8.76734H7.37675V8.4953Z' fill='white' />
    <path d='M7.79521 8.4953H7.52881V8.76734H7.79521V8.4953Z' fill='white' />
    <path d='M8.21513 8.53357H7.94873V8.80509H8.21513V8.53357Z' fill='white' />
    <path d='M8.63163 8.573H8.36523V8.84452H8.63163V8.573Z' fill='white' />
    <path d='M9.05006 8.573H8.78418V8.84452H9.05006V8.573Z' fill='white' />
    <path
      d='M9.46899 8.61188H9.20361V8.88339H9.47002L9.46899 8.61188Z'
      fill='white'
    />
    <path d='M9.9246 8.65076H9.6582V8.92227H9.9246V8.65076Z' fill='white' />
    <path d='M10.343 8.68909H10.0771V8.96061H10.343V8.68909Z' fill='white' />
    <path d='M10.7234 8.68909H10.457V8.96061H10.7234V8.68909Z' fill='white' />
    <path d='M7.52959 8.92224H7.26318V9.19376H7.52959V8.92224Z' fill='white' />
    <path d='M7.90947 8.96112H7.64307V9.23264H7.90947V8.96112Z' fill='white' />
    <path d='M8.32792 8.96112H8.06152V9.23264H8.32792V8.96112Z' fill='white' />
    <path d='M8.74538 8.99951H8.47949V9.27103H8.74538V8.99951Z' fill='white' />
    <path d='M9.16434 8.99951H8.89795V9.27103H9.16434V8.99951Z' fill='white' />
    <path d='M9.58281 9.03827H9.31641V9.31238H9.58281V9.03827Z' fill='white' />
    <path d='M10.0008 9.03827H9.73438V9.31238H10.0008V9.03827Z' fill='white' />
    <path d='M10.3802 9.07721H10.1138V9.34873H10.3802V9.07721Z' fill='white' />
    <path d='M10.7991 9.07721H10.5332V9.34873H10.7991V9.07721Z' fill='white' />
    <path d='M7.64284 9.34863H7.37695V9.62015H7.64284V9.34863Z' fill='white' />
    <path d='M8.02373 9.38757H7.75732V9.65909H8.02373V9.38757Z' fill='white' />
    <path
      d='M8.44172 9.38757H8.1748V9.65909H8.44069L8.44172 9.38757Z'
      fill='white'
    />
    <path
      d='M8.82217 9.38757H8.55371V9.65909H8.82011L8.82217 9.38757Z'
      fill='white'
    />
    <path d='M9.23952 9.42645H8.97363V9.69797H9.23952V9.42645Z' fill='white' />
    <path d='M9.65849 9.42645H9.39209V9.69797H9.65849V9.42645Z' fill='white' />
    <path d='M10.0383 9.46472H9.77246V9.73624H10.0383V9.46472Z' fill='white' />
    <path d='M10.4192 9.46472H10.1528V9.73624H10.4192V9.46472Z' fill='white' />
    <path d='M10.8377 9.46472H10.5713V9.73624H10.8377V9.46472Z' fill='white' />
    <path d='M7.71953 9.77515H7.45312V10.0467H7.71953V9.77515Z' fill='white' />
    <path d='M8.0999 9.77515H7.8335V10.0467H8.0999V9.77515Z' fill='white' />
    <path d='M8.51786 9.81396H8.25146V10.0855H8.51786V9.81396Z' fill='white' />
    <path d='M8.89821 9.81396H8.63232V10.0855H8.89821V9.81396Z' fill='white' />
    <path d='M9.31621 9.81396H9.0498V10.0855H9.31621V9.81396Z' fill='white' />
    <path d='M9.69655 9.81396H9.43066V10.0855H9.69655V9.81396Z' fill='white' />
    <path d='M10.0769 9.85333H9.81055V10.1249H10.0769V9.85333Z' fill='white' />
    <path d='M10.4573 9.85333H10.1909V10.1249H10.4573V9.85333Z' fill='white' />
    <path
      d='M10.8752 9.85333H10.6104V10.1249H10.8767L10.8752 9.85333Z'
      fill='white'
    />
    <path d='M7.79521 10.1632H7.52881V10.4347H7.79521V10.1632Z' fill='white' />
    <path d='M8.17558 10.1632H7.90918V10.4347H8.17558V10.1632Z' fill='white' />
    <path d='M8.55595 10.1995H8.28955V10.471H8.55595V10.1995Z' fill='white' />
    <path d='M8.93632 10.1995H8.66992V10.471H8.93632V10.1995Z' fill='white' />
    <path d='M9.35136 10.1995H9.08496V10.471H9.35136V10.1995Z' fill='white' />
    <path d='M9.73463 10.1995H9.46875V10.471H9.73463V10.1995Z' fill='white' />
    <path d='M10.1145 10.1995H9.84814V10.471H10.1145V10.1995Z' fill='white' />
    <path
      d='M10.4948 10.241H10.2314V10.5125H10.4973L10.4948 10.241Z'
      fill='white'
    />
    <path
      d='M10.8752 10.241H10.6104V10.5125H10.8767L10.8752 10.241Z'
      fill='white'
    />
    <path d='M7.83327 10.5513H7.56738V10.8228H7.83327V10.5513Z' fill='white' />
    <path d='M8.21513 10.5513H7.94873V10.8228H8.21513V10.5513Z' fill='white' />
    <path d='M8.59401 10.5903H8.32812V10.8618H8.59401V10.5903Z' fill='white' />
    <path d='M8.97295 10.5903H8.70654V10.8618H8.97295V10.5903Z' fill='white' />
    <path d='M9.35136 10.5903H9.08496V10.8618H9.35136V10.5903Z' fill='white' />
    <path d='M9.73463 10.5903H9.46875V10.8618H9.73463V10.5903Z' fill='white' />
    <path d='M10.1145 10.5903H9.84814V10.8618H10.1145V10.5903Z' fill='white' />
    <path
      d='M10.4948 10.5903H10.2314V10.8618H10.4973L10.4948 10.5903Z'
      fill='white'
    />
    <path
      d='M10.8752 10.5903H10.6104V10.8618H10.8767L10.8752 10.5903Z'
      fill='white'
    />
    <path d='M7.87138 10.9395H7.60498V11.211H7.87138V10.9395Z' fill='white' />
    <path d='M8.25127 10.9395H7.98486V11.211H8.25127V10.9395Z' fill='white' />
    <path d='M8.63163 10.9395H8.36523V11.211H8.63163V10.9395Z' fill='white' />
    <path d='M9.01201 10.9395H8.74561V11.211H9.01201V10.9395Z' fill='white' />
    <path d='M9.39186 10.9395H9.12598V11.211H9.39186V10.9395Z' fill='white' />
    <path d='M9.77275 10.9395H9.50635V11.211H9.77275V10.9395Z' fill='white' />
    <path d='M10.1526 10.9395H9.88623V11.211H10.1526V10.9395Z' fill='white' />
    <path d='M10.5335 10.9778H10.2671V11.2494H10.5335V10.9778Z' fill='white' />
    <path d='M10.9134 10.9778H10.647V11.2494H10.9134V10.9778Z' fill='white' />
    <path d='M7.87138 11.327H7.60498V11.5985H7.87138V11.327Z' fill='white' />
    <path d='M8.25127 11.327H7.98486V11.5985H8.25127V11.327Z' fill='white' />
    <path d='M8.63163 11.327H8.36523V11.5985H8.63163V11.327Z' fill='white' />
    <path d='M9.01201 11.327H8.74561V11.5985H9.01201V11.327Z' fill='white' />
    <path d='M9.39186 11.327H9.12598V11.5985H9.39186V11.327Z' fill='white' />
    <path d='M9.77275 11.327H9.50635V11.5985H9.77275V11.327Z' fill='white' />
    <path d='M10.1526 11.327H9.88623V11.5985H10.1526V11.327Z' fill='white' />
    <path d='M10.5335 11.327H10.2671V11.5985H10.5335V11.327Z' fill='white' />
    <path d='M10.9134 11.327H10.647V11.5985H10.9134V11.327Z' fill='white' />
    <path d='M7.90947 11.6763H7.64307V11.9478H7.90947V11.6763Z' fill='white' />
    <path d='M8.28932 11.6763H8.02344V11.9478H8.28932V11.6763Z' fill='white' />
    <path d='M8.63163 11.6763H8.36523V11.9478H8.63163V11.6763Z' fill='white' />
    <path d='M9.01201 11.6763H8.74561V11.9478H9.01201V11.6763Z' fill='white' />
    <path d='M9.39186 11.6763H9.12598V11.9478H9.39186V11.6763Z' fill='white' />
    <path d='M9.77275 11.6763H9.50635V11.9478H9.77275V11.6763Z' fill='white' />
    <path d='M10.1526 11.6763H9.88623V11.9478H10.1526V11.6763Z' fill='white' />
    <path d='M10.5335 11.6763H10.2671V11.9478H10.5335V11.6763Z' fill='white' />
    <path d='M10.9134 11.6763H10.647V11.9478H10.9134V11.6763Z' fill='white' />
    <path d='M7.90947 12.0639H7.64307V12.3354H7.90947V12.0639Z' fill='white' />
    <path d='M8.28932 12.0639H8.02344V12.3354H8.28932V12.0639Z' fill='white' />
    <path d='M8.67021 12.0639H8.40381V12.3354H8.67021V12.0639Z' fill='white' />
    <path d='M9.01201 12.0639H8.74561V12.3354H9.01201V12.0639Z' fill='white' />
    <path d='M9.39186 12.0639H9.12598V12.3354H9.39186V12.0639Z' fill='white' />
    <path d='M9.77275 12.0639H9.50635V12.3354H9.77275V12.0639Z' fill='white' />
    <path d='M10.1526 12.0639H9.88623V12.3354H10.1526V12.0639Z' fill='white' />
    <path d='M10.5335 12.0639H10.2671V12.3354H10.5335V12.0639Z' fill='white' />
    <path d='M10.9134 12.0639H10.647V12.3354H10.9134V12.0639Z' fill='white' />
    <path d='M7.90947 12.4136H7.64307V12.6852H7.90947V12.4136Z' fill='white' />
    <path d='M8.28932 12.4136H8.02344V12.6852H8.28932V12.4136Z' fill='white' />
    <path d='M8.67021 12.4136H8.40381V12.6852H8.67021V12.4136Z' fill='white' />
    <path d='M9.01201 12.4136H8.74561V12.6852H9.01201V12.4136Z' fill='white' />
    <path d='M9.39186 12.4136H9.12598V12.6852H9.39186V12.4136Z' fill='white' />
    <path d='M9.77275 12.4136H9.50635V12.6852H9.77275V12.4136Z' fill='white' />
    <path d='M10.1526 12.4136H9.88623V12.6852H10.1526V12.4136Z' fill='white' />
    <path d='M10.5335 12.4136H10.2671V12.6852H10.5335V12.4136Z' fill='white' />
    <path d='M10.9134 12.4136H10.647V12.6852H10.9134V12.4136Z' fill='white' />
    <path d='M3.80272 12.995L3.64844 13.0727H3.80272V12.995Z' fill='white' />
    <path
      d='M4.18285 13.0733V12.879L3.87891 12.9956V13.0733H4.18285Z'
      fill='white'
    />
    <path
      d='M4.52518 13.0727C4.52131 12.9812 4.50839 12.8902 4.48661 12.8012C4.41101 12.8012 4.33233 12.8401 4.25879 12.8401V13.0344H4.52518V13.0727Z'
      fill='white'
    />
    <path d='M7.90947 12.7629H7.64307V13.0344H7.90947V12.7629Z' fill='white' />
    <path d='M8.28932 12.7629H8.02344V13.0344H8.28932V12.7629Z' fill='white' />
    <path d='M8.67021 12.7629H8.40381V13.0344H8.67021V12.7629Z' fill='white' />
    <path d='M9.01201 12.7629H8.74561V13.0344H9.01201V12.7629Z' fill='white' />
    <path d='M9.39186 12.7629H9.12598V13.0344H9.39186V12.7629Z' fill='white' />
    <path d='M9.77275 12.7629H9.50635V13.0344H9.77275V12.7629Z' fill='white' />
    <path d='M10.1526 12.7629H9.88623V13.0344H10.1526V12.7629Z' fill='white' />
    <path d='M10.5335 12.7629H10.2671V13.0344H10.5335V12.7629Z' fill='white' />
    <path d='M10.9134 12.7629H10.647V13.0344H10.9134V12.7629Z' fill='white' />
    <path d='M2.66156 13.3826L2.58545 13.4209H2.66156V13.3826Z' fill='white' />
    <path
      d='M3.04228 13.422V13.2665L2.77588 13.3443V13.422H3.04228Z'
      fill='white'
    />
    <path
      d='M3.42265 13.422V13.1505L3.15625 13.2282V13.4225L3.42265 13.422Z'
      fill='white'
    />
    <path d='M3.80302 13.1505H3.53662V13.422H3.80302V13.1505Z' fill='white' />
    <path d='M4.1448 13.1505H3.87891V13.422H4.1448V13.1505Z' fill='white' />
    <path d='M4.52518 13.1505H4.25879V13.422H4.52518V13.1505Z' fill='white' />
    <path
      d='M4.67773 13.422C4.67773 13.3831 4.67773 13.3831 4.63916 13.3442L4.67773 13.422Z'
      fill='white'
    />
    <path
      d='M7.52929 13.2665C7.53502 13.3213 7.52136 13.3764 7.49072 13.422H7.52929V13.2665Z'
      fill='white'
    />
    <path d='M7.90947 13.1505H7.64307V13.422H7.90947V13.1505Z' fill='white' />
    <path d='M8.28932 13.1505H8.02344V13.422H8.28932V13.1505Z' fill='white' />
    <path d='M8.67021 13.1505H8.40381V13.422H8.67021V13.1505Z' fill='white' />
    <path d='M9.01201 13.1505H8.74561V13.422H9.01201V13.1505Z' fill='white' />
    <path d='M9.39186 13.1505H9.12598V13.422H9.39186V13.1505Z' fill='white' />
    <path d='M9.77275 13.1505H9.50635V13.422H9.77275V13.1505Z' fill='white' />
    <path d='M10.1526 13.1505H9.88623V13.422H10.1526V13.1505Z' fill='white' />
    <path d='M10.5335 13.1505H10.2671V13.422H10.5335V13.1505Z' fill='white' />
    <path d='M10.9134 13.1505H10.647V13.422H10.9134V13.1505Z' fill='white' />
    <path
      d='M1.93922 13.7712V13.6547L1.63477 13.7324V13.7712H1.93922Z'
      fill='white'
    />
    <path
      d='M2.28151 13.7712V13.4997L2.01562 13.6163V13.7717L2.28151 13.7712Z'
      fill='white'
    />
    <path d='M2.6619 13.4997H2.39551V13.7712H2.6619V13.4997Z' fill='white' />
    <path d='M3.04228 13.4997H2.77588V13.7712H3.04228V13.4997Z' fill='white' />
    <path d='M3.42265 13.4997H3.15625V13.7712H3.42265V13.4997Z' fill='white' />
    <path d='M3.80302 13.4997H3.53662V13.7712H3.80302V13.4997Z' fill='white' />
    <path d='M4.1448 13.4997H3.87891V13.7712H4.1448V13.4997Z' fill='white' />
    <path d='M4.52518 13.4997H4.25879V13.7712H4.52518V13.4997Z' fill='white' />
    <path
      d='M4.63916 13.7712H4.82996C4.79139 13.6935 4.75385 13.5769 4.71579 13.4997H4.63968L4.63916 13.7712Z'
      fill='white'
    />
    <path
      d='M7.52869 13.4997C7.49064 13.5774 7.4531 13.694 7.41504 13.7712H7.52869V13.4997Z'
      fill='white'
    />
    <path d='M7.90947 13.4997H7.64307V13.7712H7.90947V13.4997Z' fill='white' />
    <path d='M8.28932 13.4997H8.02344V13.7712H8.28932V13.4997Z' fill='white' />
    <path d='M8.67021 13.4997H8.40381V13.7712H8.67021V13.4997Z' fill='white' />
    <path d='M9.01201 13.4997H8.74561V13.7712H9.01201V13.4997Z' fill='white' />
    <path d='M9.39186 13.4997H9.12598V13.7712H9.39186V13.4997Z' fill='white' />
    <path d='M9.77275 13.4997H9.50635V13.7712H9.77275V13.4997Z' fill='white' />
    <path d='M10.1526 13.4997H9.88623V13.7712H10.1526V13.4997Z' fill='white' />
    <path d='M10.5335 13.4997H10.2671V13.7712H10.5335V13.4997Z' fill='white' />
    <path
      d='M10.647 13.4997V13.7712H10.9134C10.9134 13.6935 10.9514 13.5769 10.9514 13.4997H10.647Z'
      fill='white'
    />
    <path
      d='M1.55795 13.8484H1.36818C1.36308 13.8483 1.35799 13.8492 1.35325 13.8511C1.3485 13.853 1.3442 13.8558 1.34059 13.8595C1.33698 13.8631 1.33414 13.8674 1.33226 13.8722C1.33037 13.877 1.32946 13.8821 1.3296 13.8873C1.3296 13.965 1.36818 14.0427 1.36818 14.1199H1.59601L1.55795 13.8484Z'
      fill='white'
    />
    <path d='M1.90116 13.8484H1.63477V14.1199H1.90116V13.8484Z' fill='white' />
    <path d='M2.28151 13.8484H2.01562V14.1199H2.28151V13.8484Z' fill='white' />
    <path d='M2.6619 13.8484H2.39551V14.1199H2.6619V13.8484Z' fill='white' />
    <path d='M3.04228 13.8484H2.77588V14.1199H3.04228V13.8484Z' fill='white' />
    <path d='M3.42265 13.8484H3.15625V14.1199H3.42265V13.8484Z' fill='white' />
    <path d='M3.80302 13.8484H3.53662V14.1199H3.80302V13.8484Z' fill='white' />
    <path d='M4.1448 13.8484H3.87891V14.1199H4.1448V13.8484Z' fill='white' />
    <path d='M4.52518 13.8484H4.25879V14.1199H4.52518V13.8484Z' fill='white' />
    <path
      d='M4.63916 14.1588H4.90556V13.9261C4.90556 13.8873 4.8675 13.8873 4.8675 13.8484H4.63916V14.1588Z'
      fill='white'
    />
    <path d='M5.09513 14.1588L5.01953 14.0811V14.1588H5.09513Z' fill='white' />
    <path
      d='M7.52928 14.1588V13.8873H7.37499C7.33811 13.9855 7.28604 14.0771 7.2207 14.1588H7.52928Z'
      fill='white'
    />
    <path d='M7.90947 13.8484H7.64307V14.1199H7.90947V13.8484Z' fill='white' />
    <path d='M8.28932 13.8484H8.02344V14.1199H8.28932V13.8484Z' fill='white' />
    <path d='M8.67021 13.8484H8.40381V14.1199H8.67021V13.8484Z' fill='white' />
    <path d='M9.01201 13.8484H8.74561V14.1199H9.01201V13.8484Z' fill='white' />
    <path d='M9.39186 13.8484H9.12598V14.1199H9.39186V13.8484Z' fill='white' />
    <path d='M9.77275 13.8484H9.50635V14.1199H9.77275V13.8484Z' fill='white' />
    <path d='M10.1526 13.8484H9.88623V14.1199H10.1526V13.8484Z' fill='white' />
    <path d='M10.5335 13.8484H10.2671V14.1199H10.5335V13.8484Z' fill='white' />
    <path
      d='M10.647 14.1588H10.8367C10.8683 14.072 10.8814 13.9796 10.8753 13.8873H10.647V14.1588Z'
      fill='white'
    />
    <path
      d='M1.55988 14.236H1.37012C1.40817 14.3137 1.40817 14.4303 1.44571 14.5075H1.6L1.55988 14.236Z'
      fill='white'
    />
    <path d='M1.90116 14.236H1.63477V14.5075H1.90116V14.236Z' fill='white' />
    <path d='M2.28151 14.236H2.01562V14.5075H2.28151V14.236Z' fill='white' />
    <path d='M2.6619 14.236H2.39551V14.5075H2.6619V14.236Z' fill='white' />
    <path d='M3.04228 14.236H2.77588V14.5075H3.04228V14.236Z' fill='white' />
    <path d='M3.42265 14.236H3.15625V14.5075H3.42265V14.236Z' fill='white' />
    <path d='M3.80302 14.236H3.53662V14.5075H3.80302V14.236Z' fill='white' />
    <path d='M4.1448 14.236H3.87891V14.5075H4.1448V14.236Z' fill='white' />
    <path d='M4.52518 14.236H4.25879V14.5075H4.52518V14.236Z' fill='white' />
    <path d='M4.90556 14.236H4.63916V14.5075H4.90556V14.236Z' fill='white' />
    <path
      d='M5.01963 14.5081H5.28552V14.3138L5.17186 14.1972H5.01758V14.5081H5.01963Z'
      fill='white'
    />
    <path d='M5.62825 14.508L5.3999 14.3914V14.508H5.62825Z' fill='white' />
    <path
      d='M7.1487 14.5085V14.236C7.06971 14.3132 6.98018 14.3786 6.88281 14.4303V14.508L7.1487 14.5085Z'
      fill='white'
    />
    <path d='M7.52959 14.236H7.26318V14.5075H7.52959V14.236Z' fill='white' />
    <path d='M7.90947 14.236H7.64307V14.5075H7.90947V14.236Z' fill='white' />
    <path d='M8.28932 14.236H8.02344V14.5075H8.28932V14.236Z' fill='white' />
    <path d='M8.67021 14.236H8.40381V14.5075H8.67021V14.236Z' fill='white' />
    <path d='M9.01201 14.236H8.74561V14.5075H9.01201V14.236Z' fill='white' />
    <path d='M9.39186 14.236H9.12598V14.5075H9.39186V14.236Z' fill='white' />
    <path d='M9.77275 14.236H9.50635V14.5075H9.77275V14.236Z' fill='white' />
    <path d='M10.1526 14.236H9.88623V14.5075H10.1526V14.236Z' fill='white' />
    <path d='M10.5335 14.236H10.2671V14.5075H10.5335V14.236Z' fill='white' />
    <path
      d='M10.647 14.5086H10.7611C10.7992 14.4309 10.7992 14.3143 10.8367 14.2371H10.647V14.5086Z'
      fill='white'
    />
    <path
      d='M1.559 14.5853H1.44482C1.48288 14.663 1.48288 14.7796 1.52094 14.8568H1.559V14.5853Z'
      fill='white'
    />
    <path d='M1.90116 14.5853H1.63477V14.8568H1.90116V14.5853Z' fill='white' />
    <path d='M2.28151 14.5853H2.01562V14.8568H2.28151V14.5853Z' fill='white' />
    <path d='M2.6619 14.5853H2.39551V14.8568H2.6619V14.5853Z' fill='white' />
    <path d='M3.04228 14.5853H2.77588V14.8568H3.04228V14.5853Z' fill='white' />
    <path d='M3.42265 14.5853H3.15625V14.8568H3.42265V14.5853Z' fill='white' />
    <path d='M3.80302 14.5853H3.53662V14.8568H3.80302V14.5853Z' fill='white' />
    <path d='M4.1448 14.5853H3.87891V14.8568H4.1448V14.5853Z' fill='white' />
    <path d='M4.52518 14.5853H4.25879V14.8568H4.52518V14.5853Z' fill='white' />
    <path d='M4.90556 14.5853H4.63916V14.8568H4.90556V14.5853Z' fill='white' />
    <path d='M5.28542 14.5853H5.01953V14.8568H5.28542V14.5853Z' fill='white' />
    <path d='M5.6663 14.5853H5.3999V14.8568H5.6663V14.5853Z' fill='white' />
    <path d='M5.78027 14.8573H6.04616V14.5858H5.78027V14.8573Z' fill='white' />
    <path d='M6.42604 14.8573V14.5858H6.12158V14.8573H6.42604Z' fill='white' />
    <path d='M6.76884 14.5853H6.50244V14.8568H6.76884V14.5853Z' fill='white' />
    <path d='M7.1487 14.5853H6.88281V14.8568H7.1487V14.5853Z' fill='white' />
    <path d='M7.52959 14.5853H7.26318V14.8568H7.52959V14.5853Z' fill='white' />
    <path d='M7.90947 14.5853H7.64307V14.8568H7.90947V14.5853Z' fill='white' />
    <path d='M8.28932 14.5853H8.02344V14.8568H8.28932V14.5853Z' fill='white' />
    <path d='M8.67021 14.5853H8.40381V14.8568H8.67021V14.5853Z' fill='white' />
    <path d='M9.01201 14.5853H8.74561V14.8568H9.01201V14.5853Z' fill='white' />
    <path d='M9.39186 14.5853H9.12598V14.8568H9.39186V14.5853Z' fill='white' />
    <path d='M9.77275 14.5853H9.50635V14.8568H9.77275V14.5853Z' fill='white' />
    <path d='M10.1526 14.5853H9.88623V14.8568H10.1526V14.5853Z' fill='white' />
    <path d='M10.5335 14.5853H10.2671V14.8568H10.5335V14.5853Z' fill='white' />
    <path
      d='M10.647 14.8573C10.6896 14.7727 10.7155 14.6804 10.7231 14.5858H10.647V14.8573Z'
      fill='white'
    />
    <path d='M1.90116 14.9344H1.63477V15.206H1.90116V14.9344Z' fill='white' />
    <path d='M2.28151 14.9344H2.01562V15.206H2.28151V14.9344Z' fill='white' />
    <path d='M2.6619 14.9344H2.39551V15.206H2.6619V14.9344Z' fill='white' />
    <path d='M3.04228 14.9344H2.77588V15.206H3.04228V14.9344Z' fill='white' />
    <path d='M3.42265 14.9344H3.15625V15.206H3.42265V14.9344Z' fill='white' />
    <path d='M3.80302 14.9344H3.53662V15.206H3.80302V14.9344Z' fill='white' />
    <path d='M4.1448 14.9344H3.87891V15.206H4.1448V14.9344Z' fill='white' />
    <path d='M4.52518 14.9344H4.25879V15.206H4.52518V14.9344Z' fill='white' />
    <path d='M4.90556 14.9344H4.63916V15.206H4.90556V14.9344Z' fill='white' />
    <path d='M5.28542 14.9344H5.01953V15.206H5.28542V14.9344Z' fill='white' />
    <path d='M5.6663 14.9344H5.3999V15.206H5.6663V14.9344Z' fill='white' />
    <path d='M6.04616 14.9344H5.78027V15.206H6.04616V14.9344Z' fill='white' />
    <path d='M6.38795 14.9344H6.12207V15.206H6.38795V14.9344Z' fill='white' />
    <path d='M6.76884 14.9344H6.50244V15.206H6.76884V14.9344Z' fill='white' />
    <path d='M7.1487 14.9344H6.88281V15.206H7.1487V14.9344Z' fill='white' />
    <path d='M7.52959 14.9344H7.26318V15.206H7.52959V14.9344Z' fill='white' />
    <path d='M7.90947 14.9344H7.64307V15.206H7.90947V14.9344Z' fill='white' />
    <path d='M8.28932 14.9344H8.02344V15.206H8.28932V14.9344Z' fill='white' />
    <path d='M8.67021 14.9344H8.40381V15.206H8.67021V14.9344Z' fill='white' />
    <path d='M9.01201 14.9344H8.74561V15.206H9.01201V14.9344Z' fill='white' />
    <path d='M9.39186 14.9344H9.12598V15.206H9.39186V14.9344Z' fill='white' />
    <path d='M9.77275 14.9344H9.50635V15.206H9.77275V14.9344Z' fill='white' />
    <path d='M10.1526 14.9344H9.88623V15.206H10.1526V14.9344Z' fill='white' />
    <path
      d='M10.2671 14.9345V15.206H10.4949C10.4949 15.1671 10.5335 15.1283 10.5335 15.0894V14.934L10.2671 14.9345Z'
      fill='white'
    />
    <path
      d='M1.93971 15.3231H1.67383C1.71189 15.4008 1.74942 15.5174 1.78748 15.5946H1.94177L1.93971 15.3231Z'
      fill='white'
    />
    <path d='M2.28151 15.3231H2.01562V15.5946H2.28151V15.3231Z' fill='white' />
    <path d='M2.6619 15.3231H2.39551V15.5946H2.6619V15.3231Z' fill='white' />
    <path d='M3.04228 15.3231H2.77588V15.5946H3.04228V15.3231Z' fill='white' />
    <path d='M3.42265 15.3231H3.15625V15.5946H3.42265V15.3231Z' fill='white' />
    <path d='M3.80302 15.3231H3.53662V15.5946H3.80302V15.3231Z' fill='white' />
    <path d='M4.1448 15.3231H3.87891V15.5946H4.1448V15.3231Z' fill='white' />
    <path d='M4.52518 15.3231H4.25879V15.5946H4.52518V15.3231Z' fill='white' />
    <path d='M4.90556 15.3231H4.63916V15.5946H4.90556V15.3231Z' fill='white' />
    <path d='M5.28542 15.3231H5.01953V15.5946H5.28542V15.3231Z' fill='white' />
    <path d='M5.6663 15.3231H5.3999V15.5946H5.6663V15.3231Z' fill='white' />
    <path d='M6.04616 15.3231H5.78027V15.5946H6.04616V15.3231Z' fill='white' />
    <path d='M6.38795 15.3231H6.12207V15.5946H6.38795V15.3231Z' fill='white' />
    <path d='M6.76884 15.3231H6.50244V15.5946H6.76884V15.3231Z' fill='white' />
    <path d='M7.1487 15.3231H6.88281V15.5946H7.1487V15.3231Z' fill='white' />
    <path d='M7.52959 15.3231H7.26318V15.5946H7.52959V15.3231Z' fill='white' />
    <path d='M7.90947 15.3231H7.64307V15.5946H7.90947V15.3231Z' fill='white' />
    <path d='M8.28932 15.3231H8.02344V15.5946H8.28932V15.3231Z' fill='white' />
    <path d='M8.67021 15.3231H8.40381V15.5946H8.67021V15.3231Z' fill='white' />
    <path d='M9.01201 15.3231H8.74561V15.5946H9.01201V15.3231Z' fill='white' />
    <path d='M9.39186 15.3231H9.12598V15.5946H9.39186V15.3231Z' fill='white' />
    <path d='M9.77275 15.3231H9.50635V15.5946H9.77275V15.3231Z' fill='white' />
    <path d='M10.1526 15.3231H9.88623V15.5946H10.1526V15.3231Z' fill='white' />
    <path
      d='M10.2671 15.5946C10.3427 15.5136 10.4066 15.4222 10.4569 15.3231H10.2671V15.5946Z'
      fill='white'
    />
    <path
      d='M1.8252 15.6718C1.86325 15.7495 1.9008 15.7884 1.93886 15.8661V15.6718H1.8252Z'
      fill='white'
    />
    <path d='M2.28151 15.6718H2.01562V15.9433H2.28151V15.6718Z' fill='white' />
    <path d='M2.6619 15.6718H2.39551V15.9433H2.6619V15.6718Z' fill='white' />
    <path d='M3.04228 15.6718H2.77588V15.9433H3.04228V15.6718Z' fill='white' />
    <path d='M3.42265 15.6718H3.15625V15.9433H3.42265V15.6718Z' fill='white' />
    <path d='M3.80302 15.6718H3.53662V15.9433H3.80302V15.6718Z' fill='white' />
    <path d='M4.1448 15.6718H3.87891V15.9433H4.1448V15.6718Z' fill='white' />
    <path d='M4.52518 15.6718H4.25879V15.9433H4.52518V15.6718Z' fill='white' />
    <path d='M4.90556 15.6718H4.63916V15.9433H4.90556V15.6718Z' fill='white' />
    <path d='M5.28542 15.6718H5.01953V15.9433H5.28542V15.6718Z' fill='white' />
    <path d='M5.6663 15.6718H5.3999V15.9433H5.6663V15.6718Z' fill='white' />
    <path d='M6.04616 15.6718H5.78027V15.9433H6.04616V15.6718Z' fill='white' />
    <path d='M6.38795 15.6718H6.12207V15.9433H6.38795V15.6718Z' fill='white' />
    <path d='M6.76884 15.6718H6.50244V15.9433H6.76884V15.6718Z' fill='white' />
    <path d='M7.1487 15.6718H6.88281V15.9433H7.1487V15.6718Z' fill='white' />
    <path d='M7.52959 15.6718H7.26318V15.9433H7.52959V15.6718Z' fill='white' />
    <path d='M7.90947 15.6718H7.64307V15.9433H7.90947V15.6718Z' fill='white' />
    <path d='M8.28932 15.6718H8.02344V15.9433H8.28932V15.6718Z' fill='white' />
    <path d='M8.67021 15.6718H8.40381V15.9433H8.67021V15.6718Z' fill='white' />
    <path d='M9.01201 15.6718H8.74561V15.9433H9.01201V15.6718Z' fill='white' />
    <path d='M9.39186 15.6718H9.12598V15.9433H9.39186V15.6718Z' fill='white' />
    <path d='M9.77275 15.6718H9.50635V15.9433H9.77275V15.6718Z' fill='white' />
    <path
      d='M9.88623 15.6718V15.9434H10.1146C10.1526 15.9045 10.1526 15.8656 10.1902 15.8656V15.6713L9.88623 15.6718Z'
      fill='white'
    />
    <path
      d='M2.28151 16.0211H2.01562C2.09122 16.0988 2.12928 16.2154 2.20539 16.2926H2.28099L2.28151 16.0211Z'
      fill='white'
    />
    <path d='M2.6619 16.0211H2.39551V16.2942H2.6619V16.0211Z' fill='white' />
    <path d='M3.04228 16.0211H2.77588V16.2942H3.04228V16.0211Z' fill='white' />
    <path d='M3.42265 16.0211H3.15625V16.2942H3.42265V16.0211Z' fill='white' />
    <path d='M3.80302 16.0211H3.53662V16.2942H3.80302V16.0211Z' fill='white' />
    <path d='M4.1448 16.0211H3.87891V16.2942H4.1448V16.0211Z' fill='white' />
    <path d='M4.52518 16.0211H4.25879V16.2942H4.52518V16.0211Z' fill='white' />
    <path d='M4.90556 16.0211H4.63916V16.2942H4.90556V16.0211Z' fill='white' />
    <path d='M5.28542 16.0211H5.01953V16.2942H5.28542V16.0211Z' fill='white' />
    <path d='M5.6663 16.0211H5.3999V16.2942H5.6663V16.0211Z' fill='white' />
    <path d='M6.04616 16.0211H5.78027V16.2942H6.04616V16.0211Z' fill='white' />
    <path d='M6.38795 16.0211H6.12207V16.2942H6.38795V16.0211Z' fill='white' />
    <path d='M6.76884 16.0211H6.50244V16.2942H6.76884V16.0211Z' fill='white' />
    <path d='M7.1487 16.0211H6.88281V16.2942H7.1487V16.0211Z' fill='white' />
    <path d='M7.52959 16.0211H7.26318V16.2942H7.52959V16.0211Z' fill='white' />
    <path d='M7.90947 16.0211H7.64307V16.2942H7.90947V16.0211Z' fill='white' />
    <path d='M8.28932 16.0211H8.02344V16.2942H8.28932V16.0211Z' fill='white' />
    <path d='M8.67021 16.0211H8.40381V16.2942H8.67021V16.0211Z' fill='white' />
    <path d='M9.01201 16.0211H8.74561V16.2942H9.01201V16.0211Z' fill='white' />
    <path d='M9.39186 16.0211H9.12598V16.2942H9.39186V16.0211Z' fill='white' />
    <path d='M9.77275 16.0211H9.50635V16.2942H9.77275V16.0211Z' fill='white' />
    <path
      d='M9.88623 16.2538C9.92803 16.1818 9.98001 16.1163 10.0405 16.0594H9.88623V16.2538Z'
      fill='white'
    />
    <path
      d='M2.6619 16.3704H2.39551V16.5258L2.50968 16.6424H2.66397L2.6619 16.3704Z'
      fill='white'
    />
    <path d='M3.04228 16.3704H2.77588V16.6419H3.04228V16.3704Z' fill='white' />
    <path d='M3.42265 16.3704H3.15625V16.6419H3.42265V16.3704Z' fill='white' />
    <path d='M3.80302 16.3704H3.53662V16.6419H3.80302V16.3704Z' fill='white' />
    <path d='M4.1448 16.3704H3.87891V16.6419H4.1448V16.3704Z' fill='white' />
    <path d='M4.52518 16.3704H4.25879V16.6419H4.52518V16.3704Z' fill='white' />
    <path d='M4.90556 16.3704H4.63916V16.6419H4.90556V16.3704Z' fill='white' />
    <path d='M5.28542 16.3704H5.01953V16.6419H5.28542V16.3704Z' fill='white' />
    <path d='M5.6663 16.3704H5.3999V16.6419H5.6663V16.3704Z' fill='white' />
    <path d='M6.04616 16.3704H5.78027V16.6419H6.04616V16.3704Z' fill='white' />
    <path d='M6.38795 16.3704H6.12207V16.6419H6.38795V16.3704Z' fill='white' />
    <path d='M6.76884 16.3704H6.50244V16.6419H6.76884V16.3704Z' fill='white' />
    <path d='M7.1487 16.3704H6.88281V16.6419H7.1487V16.3704Z' fill='white' />
    <path d='M7.52959 16.3704H7.26318V16.6419H7.52959V16.3704Z' fill='white' />
    <path d='M7.90947 16.3704H7.64307V16.6419H7.90947V16.3704Z' fill='white' />
    <path d='M8.28932 16.3704H8.02344V16.6419H8.28932V16.3704Z' fill='white' />
    <path d='M8.67021 16.3704H8.40381V16.6419H8.67021V16.3704Z' fill='white' />
    <path d='M9.01201 16.3704H8.74561V16.6419H9.01201V16.3704Z' fill='white' />
    <path d='M9.39186 16.3704H9.12598V16.6419H9.39186V16.3704Z' fill='white' />
    <path d='M9.50635 16.6419L9.77275 16.3704H9.50635V16.6419Z' fill='white' />
    <path d='M2.58545 16.758L2.66156 16.8357V16.758H2.58545Z' fill='white' />
    <path
      d='M3.04228 16.758H2.77588V16.9528L2.89005 17.0694H3.04434L3.04228 16.758Z'
      fill='white'
    />
    <path d='M3.42265 16.758H3.15625V17.0295H3.42265V16.758Z' fill='white' />
    <path d='M3.80302 16.758H3.53662V17.0295H3.80302V16.758Z' fill='white' />
    <path d='M4.1448 16.758H3.87891V17.0295H4.1448V16.758Z' fill='white' />
    <path d='M4.52518 16.758H4.25879V17.0295H4.52518V16.758Z' fill='white' />
    <path d='M4.90556 16.758H4.63916V17.0295H4.90556V16.758Z' fill='white' />
    <path d='M5.28542 16.758H5.01953V17.0295H5.28542V16.758Z' fill='white' />
    <path d='M5.6663 16.758H5.3999V17.0295H5.6663V16.758Z' fill='white' />
    <path d='M6.04616 16.758H5.78027V17.0295H6.04616V16.758Z' fill='white' />
    <path d='M6.38795 16.758H6.12207V17.0295H6.38795V16.758Z' fill='white' />
    <path d='M6.76884 16.758H6.50244V17.0295H6.76884V16.758Z' fill='white' />
    <path d='M7.1487 16.758H6.88281V17.0295H7.1487V16.758Z' fill='white' />
    <path d='M7.52959 16.758H7.26318V17.0295H7.52959V16.758Z' fill='white' />
    <path d='M7.90947 16.758H7.64307V17.0295H7.90947V16.758Z' fill='white' />
    <path d='M8.28932 16.758H8.02344V17.0295H8.28932V16.758Z' fill='white' />
    <path d='M8.67021 16.758H8.40381V17.0295H8.67021V16.758Z' fill='white' />
    <path d='M9.01201 16.758H8.74561V17.0295H9.01201V16.758Z' fill='white' />
    <path
      d='M9.12598 16.9907C9.22255 16.9228 9.31168 16.8448 9.39186 16.758H9.12598V16.9907Z'
      fill='white'
    />
    <path d='M3.00391 17.1072L3.04145 17.145V17.1072H3.00391Z' fill='white' />
    <path
      d='M3.15625 17.1072V17.2238C3.23608 17.2898 3.32606 17.3423 3.42265 17.3792V17.1077L3.15625 17.1072Z'
      fill='white'
    />
    <path d='M3.80302 17.1072H3.53662V17.3787H3.80302V17.1072Z' fill='white' />
    <path d='M4.1448 17.1072H3.87891V17.3787H4.1448V17.1072Z' fill='white' />
    <path d='M4.52518 17.1072H4.25879V17.3787H4.52518V17.1072Z' fill='white' />
    <path d='M4.90556 17.1072H4.63916V17.3787H4.90556V17.1072Z' fill='white' />
    <path d='M5.28542 17.1072H5.01953V17.3787H5.28542V17.1072Z' fill='white' />
    <path d='M5.6663 17.1072H5.3999V17.3787H5.6663V17.1072Z' fill='white' />
    <path d='M6.04616 17.1072H5.78027V17.3787H6.04616V17.1072Z' fill='white' />
    <path d='M6.38795 17.1072H6.12207V17.3787H6.38795V17.1072Z' fill='white' />
    <path d='M6.76884 17.1072H6.50244V17.3787H6.76884V17.1072Z' fill='white' />
    <path d='M7.1487 17.1072H6.88281V17.3787H7.1487V17.1072Z' fill='white' />
    <path d='M7.52959 17.1072H7.26318V17.3787H7.52959V17.1072Z' fill='white' />
    <path d='M7.90947 17.1072H7.64307V17.3787H7.90947V17.1072Z' fill='white' />
    <path d='M8.28932 17.1072H8.02344V17.3787H8.28932V17.1072Z' fill='white' />
    <path
      d='M8.40381 17.1071V17.3787H8.51798C8.59358 17.3398 8.63215 17.3009 8.70775 17.3009V17.1066L8.40381 17.1071Z'
      fill='white'
    />
    <path
      d='M8.74561 17.2238C8.82172 17.1849 8.85978 17.146 8.93538 17.1072H8.74561V17.2238Z'
      fill='white'
    />
    <path d='M3.57324 17.4538L3.80107 17.5704V17.4538H3.57324Z' fill='white' />
    <path
      d='M3.87891 17.4538V17.6092C3.95451 17.6481 4.0692 17.687 4.1448 17.7258V17.4932L3.87891 17.4538Z'
      fill='white'
    />
    <path d='M4.52518 17.4538H4.25879V17.7253H4.52518V17.4538Z' fill='white' />
    <path d='M4.90556 17.4538H4.63916V17.7253H4.90556V17.4538Z' fill='white' />
    <path d='M5.28542 17.4538H5.01953V17.7253H5.28542V17.4538Z' fill='white' />
    <path d='M5.6663 17.4538H5.3999V17.7253H5.6663V17.4538Z' fill='white' />
    <path d='M6.04616 17.4538H5.78027V17.7253H6.04616V17.4538Z' fill='white' />
    <path d='M6.38795 17.4538H6.12207V17.7253H6.38795V17.4538Z' fill='white' />
    <path d='M6.76884 17.4538H6.50244V17.7253H6.76884V17.4538Z' fill='white' />
    <path d='M7.1487 17.4538H6.88281V17.7253H7.1487V17.4538Z' fill='white' />
    <path d='M7.52959 17.4538H7.26318V17.7253H7.52959V17.4538Z' fill='white' />
    <path
      d='M7.64307 17.4538V17.7253C7.72585 17.6818 7.81642 17.6554 7.90947 17.6476V17.4921L7.64307 17.4538Z'
      fill='white'
    />
    <path
      d='M8.02344 17.4538V17.5704C8.09904 17.5315 8.21321 17.4927 8.28932 17.4538H8.02344Z'
      fill='white'
    />
    <path
      d='M4.63916 17.8445C4.71527 17.8834 4.82996 17.8834 4.90556 17.9223V17.8445H4.63916Z'
      fill='white'
    />
    <path
      d='M5.01953 17.8445V17.9223C5.09513 17.9223 5.2093 17.9611 5.28542 17.9611V17.8445H5.01953Z'
      fill='white'
    />
    <path d='M5.3999 17.8445V17.9611H5.6663V17.8445H5.3999Z' fill='white' />
    <path d='M5.78027 17.8445V18H6.04616V17.8445H5.78027Z' fill='white' />
    <path d='M6.12207 17.8445V17.9611H6.38795V17.8445H6.12207Z' fill='white' />
    <path
      d='M6.50244 17.8445V17.9611C6.59297 17.9673 6.68378 17.9541 6.76884 17.9223V17.8445H6.50244Z'
      fill='white'
    />
    <path
      d='M6.88281 17.8445V17.9223C6.95841 17.9223 7.07258 17.8834 7.1487 17.8834H6.88281V17.8445Z'
      fill='white'
    />
    <mask id='path-498-inside-1_9934_3503' fill='white'>
      <path d='M49.1431 0H164V18H49.1431V0Z' />
    </mask>
    <path
      d='M49.1431 18H50.1431V0H49.1431H48.1431V18H49.1431Z'
      fill='white'
      mask='url(#path-498-inside-1_9934_3503)'
    />
    <path
      d='M60.5182 9.36496C60.5182 11.7995 62.3363 13.6701 64.6894 13.6701C66.9505 13.6701 68.0893 12.1908 68.0893 10.5623V9.97856H64.7911V10.8741H67.1868C67.2032 11.7563 66.4025 12.7879 64.6894 12.7879C62.7957 12.7879 61.4797 11.3683 61.4797 9.36496C61.4797 7.43793 62.9008 5.98851 64.8502 5.98851C66.1202 5.98851 67.1278 6.3036 68.0598 6.96032L68.1189 6.91389V6.07807C67.4231 5.58387 66.2417 5.10626 64.8206 5.10626C62.4118 5.10626 60.5182 6.99017 60.5182 9.36496ZM59.1431 9.36496C59.1431 12.5922 61.5093 15.0001 64.6894 15.0001C67.5872 15.0001 69.3627 13.1626 69.3627 10.1875V8.66181H64.7911V9.52749H68.5324V10.3335C68.5324 12.6651 67.0982 14.1146 64.6894 14.1146C62.0409 14.1146 60.0751 12.0681 60.0751 9.36165C60.0751 6.73478 62.1459 4.6585 64.8206 4.6585C66.0907 4.6585 67.2459 4.97359 68.1189 5.58387V4.70493C67.2754 4.09133 66.1662 3.77624 64.8206 3.77624C61.611 3.77624 59.1431 6.2439 59.1431 9.36496ZM71.2399 10.1278V14.7447H72.1129V10.1444C72.1129 9.11289 72.7791 8.37989 73.7702 8.37989C74.0656 8.37989 74.3314 8.45618 74.6136 8.57558C74.7318 8.29034 74.8499 8.05153 74.9976 7.82931C74.6858 7.62035 74.2297 7.48437 73.7866 7.48437C72.2868 7.48437 71.2399 8.57558 71.2399 10.1278ZM69.9534 14.7447H70.8264V10.1278C70.8264 8.3036 72.0374 7.06314 73.7997 7.06314C74.3905 7.06314 74.9976 7.25883 75.2634 7.42135C75.4275 7.22566 75.6047 7.01671 75.841 6.82433C75.293 6.43627 74.5546 6.21074 73.7571 6.21074C71.4368 6.21074 69.9567 7.79614 69.9567 10.1411V14.7447H69.9534ZM83.6288 9.57392V10.8741C84.1473 10.1709 84.5904 9.56065 85.0039 9.04987C86.0541 7.74971 86.9697 7.03329 88.3908 7.03329C90.3139 7.03329 91.7185 8.49929 91.7185 10.559C91.7185 12.5756 90.3434 14.1146 88.4498 14.1146C86.9107 14.1146 85.5815 13.0532 85.2697 11.6038L84.6495 12.4562C85.1385 13.8757 86.5726 14.9968 88.4334 14.9968C90.8292 14.9968 92.5882 13.0532 92.5882 10.559C92.5882 8.03495 90.8127 6.13445 88.3875 6.13445C85.8769 6.13777 84.725 8.03495 83.6288 9.57392ZM86.3363 10.234H86.3068L85.6275 11.1759C85.7456 12.2505 86.8253 13.6867 88.4531 13.6867C90.1104 13.6867 91.3083 12.3268 91.3083 10.549C91.3083 8.77127 90.0809 7.45452 88.394 7.45452C86.7531 7.45452 85.808 8.66513 85.1417 9.56065C84.8168 9.99515 84.2556 10.695 83.6321 11.5772V13.0134C84.2097 12.1477 84.9941 11.1295 85.5684 10.4296C86.5431 9.24888 87.1371 8.35336 88.3776 8.35336C89.5886 8.35336 90.4189 9.29531 90.4189 10.549C90.4189 11.8492 89.6346 12.8044 88.4531 12.8044C87.2126 12.8044 86.3396 11.6535 86.3396 10.3699V10.234H86.3363ZM85.4634 3.00012V6.72151C85.7292 6.51256 86.0246 6.25717 86.3363 6.13777V3.00012H85.4634ZM84.1605 8.08138C84.4263 7.73644 84.7217 7.36496 85.0334 7.04987V3.00012H84.1605V8.08138ZM80.6128 12.3401L80.5964 12.3235C80.2256 12.622 79.6217 12.8011 79.0441 12.8011C77.8626 12.8011 76.9733 11.9056 76.9733 10.5756C76.9733 9.30526 77.8462 8.33346 79.0146 8.33346C80.2715 8.33346 81.0395 9.25883 81.0395 10.4993V14.7447H81.9124V10.4562C81.9124 8.72152 80.7146 7.4512 79.0277 7.4512C77.3572 7.4512 76.0708 8.72151 76.0708 10.5756C76.0708 12.4131 77.3408 13.7298 79.0277 13.6834C79.6644 13.6668 80.3142 13.428 80.6095 13.219V12.3401H80.6128ZM74.758 10.5623C74.758 13.1626 76.5762 15.0001 79.031 15.0001C79.579 15.0001 80.2124 14.8343 80.6128 14.5225V13.6403C80.347 13.8658 79.6972 14.1179 79.031 14.1179C77.0192 14.1179 75.6605 12.6817 75.6605 10.5623C75.6605 8.54573 77.1111 7.03661 79.031 7.03661C80.9377 7.03661 82.3292 8.45617 82.3292 10.4429V14.748H83.2153V10.4263C83.2153 7.9454 81.4858 6.12118 79.031 6.12118C76.6221 6.1245 74.758 8.05153 74.758 10.5623Z'
      fill='white'
    />
    <path
      d='M102.52 3.96216H105.038V14.7316H103.305V6.31042L100.21 14.3734H98.9072L95.8124 6.4464V14.735H94.0796V3.96216H96.5968L99.557 11.7267L102.52 3.96216Z'
      fill='white'
    />
    <path
      d='M106.38 10.662C106.38 8.10476 108.054 6.35352 110.479 6.35352C112.921 6.35352 114.578 8.10476 114.578 10.662C114.578 13.2192 112.921 14.9538 110.479 14.9538C108.038 14.9572 106.38 13.2059 106.38 10.662ZM112.878 10.662C112.878 9.10642 111.871 7.98536 110.479 7.98536C109.088 7.98536 108.08 9.10642 108.08 10.662C108.08 12.2043 109.088 13.3253 110.479 13.3253C111.871 13.3253 112.878 12.2043 112.878 10.662Z'
      fill='white'
    />
    <path
      d='M115.578 10.6488C115.578 8.12147 117.163 6.35696 119.411 6.35696C120.507 6.35696 121.511 6.85116 121.987 7.61401H122.063V3.10986H123.766V10.5891C123.766 13.1928 122.108 14.9573 119.68 14.9573C117.264 14.9573 115.578 13.1895 115.578 10.6488ZM122.059 10.5593C122.059 9.01699 121.098 7.98549 119.647 7.98549C118.226 7.98549 117.278 9.01699 117.278 10.5891C117.278 12.1745 118.285 13.3255 119.677 13.3255C121.068 13.3255 122.059 12.1745 122.059 10.5593Z'
      fill='white'
    />
    <path
      d='M124.869 10.6785C124.869 8.10474 126.513 6.35681 128.955 6.35681C131.455 6.35681 133.054 7.98865 133.054 10.5293V14.7316H131.396V13.5044H131.321C130.819 14.3867 129.811 14.9538 128.731 14.9538C126.365 14.9571 124.869 13.2955 124.869 10.6785ZM131.354 10.589C131.354 9.0467 130.376 7.98534 128.955 7.98534C127.533 7.98534 126.572 9.0467 126.572 10.6321C126.572 12.2341 127.533 13.3087 128.955 13.3087C130.376 13.3087 131.354 12.2042 131.354 10.589Z'
      fill='white'
    />
    <path
      d='M134.533 12.6986V3.10986H136.236V12.4001C136.236 12.9241 136.548 13.2392 137.037 13.2392C137.201 13.2392 137.539 13.1928 137.808 13.1497V14.7351C137.365 14.8246 136.905 14.8843 136.61 14.8843C135.288 14.881 134.533 14.0717 134.533 12.6986Z'
      fill='white'
    />
  </svg>
);

export default GrabModalLogo;
